import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import axios from "axios";
import React, { useState } from "react";
import { token } from "../../API";

const CreateCat = ({ callback, cats }) => {
  const [uzCat, setUzCat] = useState("");
  const [engCat, setEngCat] = useState("");
  const [ruCat, setRuCat] = useState("");
  const [index, setIndex] = useState(0);
  const [category, setCategory] = useState(1);

  const createNewTag = () => {
    if (ruCat !== "" && engCat !== "" && uzCat !== "") {
      let cattoAdd = {
        parentCategory: index == 1 ? category : null,
        textEn: engCat,
        textRu: ruCat,
        textUz: uzCat,
      };
      setCat(cattoAdd);
      setUzCat("");
      setEngCat("");
      setRuCat("");
    }
  };
  const setCat = async (body) => {
    const url = `http://164.90.236.174:1988/koinot/category`;
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      const res = await axios.post(url, body, headers);
      callback();
      return res;
    } catch (error) {
      console.error(error);
      return { error: true, error };
    }
  };
  return (
    <div>
      <br />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          createNewTag();
        }}
        className="form-group"
      >
        <div className="row w-50 ms-1">
          <div
            className={`col-6 bg-${
              index == 0 ? "info" : "white"
            } p-2 border-bottom border-info rounded text-center `}
            onClick={() => setIndex(0)}
          >
            Katta kategoriya
          </div>
          <div
            className={`col-6 bg-${
              index == 1 ? "info" : "white"
            } p-2 border-bottom border-info rounded text-center `}
            onClick={() => setIndex(1)}
          >
            Kichik kategoriya
          </div>
        </div>
        <br />
        {index == 1 ? (
          <div className="w-100">
            <FormControl fullWidth variant="filled">
              <InputLabel id="demo-simple-select-label">Categories</InputLabel>
              <Select
                displayEmpty
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                defaultValue={category}
                value={category}
                label={cats.length != 0 ? cats[0].textUz : "Kategoriyalar yo'q"}
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
              >
                {cats.map((v, i) => (
                  <MenuItem value={v.id} key={i}>
                    {v.textUz}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
          </div>
        ) : (
          ""
        )}
        <br />

        <label htmlFor="uzcat">O'zbek tilida</label>
        <input
          type="text"
          className="form-control"
          id="uzcat"
          value={uzCat}
          placeholder="kategoriyaning o'zbekcha nomi"
          onChange={(e) => setUzCat(e.target.value)}
        />
        <br />
        <label htmlFor="engCat">In English</label>
        <input
          type="text"
          className="form-control"
          id="engCat"
          value={engCat}
          placeholder="in english"
          onChange={(e) => setEngCat(e.target.value)}
        />
        <br />
        <label htmlFor="ruCat">Hа русском</label>

        <input
          type="text"
          className="form-control"
          id="ruCat"
          value={ruCat}
          placeholder="на русском"
          onChange={(e) => setRuCat(e.target.value)}
        />
        <button className="btn btn-info">
          Bazaga yangi kategoriya qo'shish
        </button>
      </form>
    </div>
  );
};

export default CreateCat;



// WEBPACK FOOTER //
// ./src/Components/CreateCat/index.jsx